module.exports = __webpack_public_path__ + "img/aval-mini.5698261d.png";